export const UPDATE_USER = "UPDATE_USER";
export const LOGOUT = "LOGOUT";

//export default actions;
